/* eslint-disable array-callback-return */
/* eslint-disable react/no-deprecated */
/* eslint-disable react/no-arrow-function-lifecycle */
/* eslint class-methods-use-this: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Table } from 'react-bootstrap';
import SessionStore from 'stores/SessionStore';
import moment from 'moment';
import DriverStore from 'stores/DriverStore';
import DriverWebAPIUtils from 'utils/DriverWebAPIUtils';

import { getSignedUrl } from 'utils/DocumentsAPIUtils';
import { getFileIconClass } from '../../../../helpers/helper_functions';

class DriverDocuments extends React.Component {
  static propTypes = {
    id: PropTypes.string,
  };

  static defaultProps = {
    id: '',
  };

  constructor(props) {
    super(props);

    const user = SessionStore.getUser();

    this.state = {
      userRole: user._type,
      signedUrls: {},
      documents: [],
    };
  }

  componentDidMount = () => {
    DriverStore.addChangeListener(this.getManifests);
    DriverWebAPIUtils.getDriverManifests(this.props.id);
  };

  componentWillReceiveProps(nextProps) {
    // If the user attempts to switch drivers using the search bar, update manifests...
    if (nextProps && nextProps.id !== this.props.id) {
      DriverWebAPIUtils.getDriverManifests(nextProps.id);
    }
  }

  componentWillUnmount() {
    DriverStore.removeChangeListener(this.getManifests);
  }

  /** *************  COMPONENT STATE HANDLERS ******************** */

  getManifests = () => {
    const manifest = DriverStore.getManifest();
    if (!manifest || !manifest.length) {
      return null;
    }
    this.setState({ documents: manifest }, () => this.getSignedUrl());
  };

  getViewableDocs(docs, initialUserRole) {
    const userRole = this.state.userRole || initialUserRole;
    return docs.filter((doc) => {
      if (doc.hasOwnProperty('show') && doc.show) {
        if (!doc.user_visibility || userRole === 'Admin') {
          return true;
        }
        return doc.user_visibility.indexOf(userRole) > -1;
      }
      return false;
    });
  }

  getSignedUrl = async () => {
    const { t } = this.props;
    // Find document paths
    const docs = this.state.documents;
    const signedUrls = {};
    if (docs.length > 0) {
      try {
        // userRole from above is not in this.state yet, but we need the value to determine visibility of documents
        const viewableDocs = this.getViewableDocs(docs, this.state.userRole);
        const promises = viewableDocs.map(async (d) => {
          if (d.uri) {
            const { data: signedUrl } = await getSignedUrl(d.uri);
            return signedUrl;
          }

          console.warn(`${t('DOCUMENT_URI_MISSING', { docName: d.name })}`);
        });

        const urls = await Promise.all(promises);
        const mappedUrls = urls.map((url) => url?.getSignedUrl?.signedUrl);

        viewableDocs.map((d, i) => {
          signedUrls[d.uri] = mappedUrls[i];
        });
      } catch (e) {
        console.error(t('SHIPMENT_DOCUMENT'), t('ERROR_SIGNED_URL'), e);
      }
    }
    this.setState({ signedUrls });
  };

  /** *************  EVENT HANDLERS ******************** */

  // User Clicks Depart Button
  departManifest = (doc) => {
    if (!doc) {
      return null;
    }
    DriverWebAPIUtils.departManifest(doc);
  };

  /** *************  VIEW RENDERS  ******************** */

  renderLink(doc) {
    const { t } = this.props;
    const signedUrl = this.state.signedUrls[doc.uri];
    if (!signedUrl)
      return <span>{t('DOCUMENT_URI_MISSING', { docName: doc.name })}</span>;
    return (
      <a
        className="driver-driverDocuments-viewManifest heap"
        href={signedUrl}
        target="blank"
      >
        {doc.name}
      </a>
    );
  }

  renderDocuments(docs) {
    const scopedDocs = this.getViewableDocs(docs);
    const { t } = this.props;

    return scopedDocs
      .filter((doc) => !!(doc.uri || doc.path))
      .map((doc, i) => {
        const extension = (doc.uri || doc.path).split('.').pop().toUpperCase();
        const key = `shipment-document-${i}`;
        const timestamp =
          doc.meta && doc.meta.timestamp
            ? moment(doc.meta.timestamp).format('LLLL')
            : '';
        const departed =
          doc.meta && doc.meta.departed ? doc.meta.departed : false;

        // this is pretty hacky but the only alternative is creating a new component for order docs

        const topItemStyle =
          i === 0 && this.props.isOrder
            ? { borderTop: '2px solid transparent' }
            : {};

        return (
          <tr style={topItemStyle} key={key}>
            <td>
              <i className={getFileIconClass(extension)} />
            </td>
            <td>{this.renderLink(doc)}</td>
            <td>{timestamp}</td>
            <td>
              {!departed ? (
                <button
                  type="primary"
                  className="button button-green driver-driverDocuments-dispatchDriver heap"
                  onClick={() => this.departManifest(doc)}
                >
                  {t('DEPART')}
                </button>
              ) : (
                <span>{t('DEPARTED')}</span>
              )}
            </td>
          </tr>
        );
      });
  }

  renderDocumentList() {
    const { t } = this.props;
    const docs = this.state.documents;
    if (docs.length === 0) {
      return <i>{t('DRIVER_DOES_NOT_HAVE_DOCUMENTS')}</i>;
    }

    return (
      <Table>
        <tbody>{this.renderDocuments(docs)}</tbody>
      </Table>
    );
  }

  render() {
    return <div>{this.renderDocumentList()}</div>;
  }
}

export default withTranslation()(DriverDocuments);
